import { render, staticRenderFns } from "./PaymentReceivedHeader.vue?vue&type=template&id=51e66570&scoped=true&"
import script from "./PaymentReceivedHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentReceivedHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReceivedHeader.vue?vue&type=style&index=0&id=51e66570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e66570",
  null
  
)

export default component.exports